module.exports = "/_next/static/pages/test-guidelines/f0395dbefa4210b641c8ac62249bd1a1.png";